import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function Navbar() {
  const { currentUser, userRole, logout } = useAuth();

  return (
    <nav className="bg-burgundy text-white px-6 py-4 flex items-center justify-between">
      <h2 className="text-2xl font-bold">VentES</h2>
      <div className="flex items-center space-x-4">
        <Link to="/" className="hover:underline">
          Home
        </Link>
        {currentUser ? (
          <>
            <Link to="/dashboard" className="hover:underline">
              Dashboard
            </Link>
            {userRole === "admin" && <Link to="/admin">Manage equipment</Link>}
            <Link to="/profile" className="hover:underline">
              Profile
            </Link>
            <Link to="/reservation" className="hover:underline">
              Reservation
            </Link>
            <button
              onClick={logout}
              className="bg-navy px-3 py-1 rounded hover:bg-opacity-80"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/signin" className="hover:underline">
              Sign In
            </Link>
            <Link to="/signup" className="hover:underline">
              Sign Up
            </Link>
          </>
        )}
      </div>
    </nav>
  );
}
